import { Config } from './Config'
import { Stage } from '../common/models/stage'

/**
 * Configuration overrides for the Beta environment.
 */
export class BetaConfig extends Config {
  public stage = Stage.BETA
  public safesEndpoint = `https://1vnm8inod0.execute-api.us-east-1.amazonaws.com/jwt/safes`
  public brassEndpoint = `https://1vnm8inod0.execute-api.us-east-1.amazonaws.com/jwt/brass`
  public approvalEndpoint = `https://1vnm8inod0.execute-api.us-east-1.amazonaws.com/jwt/approval`
}
